import { getDriverCommentByBooking } from "../../data/repository/driverCommentRepo";

export const getDriverCommentByBookingUseCase = async (counterBooking) => {
  return await getDriverCommentByBooking(counterBooking);
};
